import { render, staticRenderFns } from "./topup.vue?vue&type=template&id=4cbe3f2d&"
import script from "./topup.vue?vue&type=script&lang=js&"
export * from "./topup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports